export function waitForIceGatheringComplete(
  peerConnection,
  timeoutMs = 10_000,
  signal,
) {
  if (signal?.aborted) return Promise.reject(signal.reason);
  if (peerConnection.iceGatheringState === "complete") {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const cleanup = () => {
      clearTimeout(timeoutId);
      signal?.removeEventListener("abort", handleAbort);
      peerConnection.removeEventListener(
        "icegatheringstatechange",
        handleStateChange,
      );
    };
    const finish = (error) => {
      cleanup();
      if (error) reject(error);
      else resolve();
    };
    const handleStateChange = () => {
      if (peerConnection.iceGatheringState === "complete") finish();
    };
    const handleAbort = () => finish(signal.reason);
    const timeoutId = setTimeout(
      () => finish(new Error("ICE candidate gathering timed out")),
      timeoutMs,
    );

    peerConnection.addEventListener(
      "icegatheringstatechange",
      handleStateChange,
    );
    signal?.addEventListener("abort", handleAbort, { once: true });
    handleStateChange();
  });
}

export function waitForDataChannelOpen(
  dataChannel,
  peerConnection,
  timeoutMs = 10_000,
  signal,
) {
  if (signal?.aborted) return Promise.reject(signal.reason);
  if (dataChannel.readyState === "open") {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const cleanup = () => {
      clearTimeout(timeoutId);
      signal?.removeEventListener("abort", handleAbort);
      dataChannel.removeEventListener("open", handleOpen);
      dataChannel.removeEventListener("error", handleError);
      peerConnection.removeEventListener(
        "connectionstatechange",
        handleConnectionStateChange,
      );
    };
    const finish = (error) => {
      cleanup();
      if (error) reject(error);
      else resolve();
    };
    const handleOpen = () => finish();
    const handleAbort = () => finish(signal.reason);
    const handleError = () =>
      finish(new Error("Realtime transcription data channel failed"));
    const handleConnectionStateChange = () => {
      if (
        peerConnection.connectionState === "failed" ||
        peerConnection.connectionState === "closed"
      ) {
        finish(
          new Error(
            `Realtime peer connection ${peerConnection.connectionState}`,
          ),
        );
      }
    };
    const timeoutId = setTimeout(
      () => finish(new Error("Realtime transcription connection timed out")),
      timeoutMs,
    );

    dataChannel.addEventListener("open", handleOpen);
    signal?.addEventListener("abort", handleAbort, { once: true });
    dataChannel.addEventListener("error", handleError);
    peerConnection.addEventListener(
      "connectionstatechange",
      handleConnectionStateChange,
    );
    if (dataChannel.readyState === "open") handleOpen();
    else handleConnectionStateChange();
  });
}
